<input type="checkbox" [(ngModel)]="value">&nbsp;&nbsp;{{ 'Register.Label.AgreeToPrivacy' | translate }}<span
    *ngIf="showAsterisk" class="required-field">*</span>
